<template>
  <div class="password-container">
    <button @click="revealAndCopy" class="toggle-button btn btn-success">
      {{ showPassword ? displayedPassword : 'Reveal + Copy Password' }}
    </button>
    <button @click="copyToClipboard" class="copy-button btn btn-success">
      {{ copied ? '...Copied ✔️' : 'Copy Password' }}
    </button>
    <button v-if="downloadUrl" @click="downloadFile" class="download-button btn btn-success">
      Download
    </button>
  </div class="password-container">
</template>

<script>
export default {
  props: {
    password: String,
    downloadUrl: String
  },
  data() {
    return {
      showPassword: false,
      copied: false,
      timeout: null,
      copyTimeout: null
    };
  },
  computed: {
    displayedPassword() {
      return this.showPassword ? this.password : '*'.repeat(this.password.length);
    }
  },
  methods: {
    revealAndCopy() {
      this.showPassword = true;
      this.copyToClipboard();
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.showPassword = false;
      }, 10000);
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.password).then(() => {
        this.copied = true;
        clearTimeout(this.copyTimeout);
        this.copyTimeout = setTimeout(() => {
          this.copied = false;
        }, 2000);
      });
    },
    downloadFile() {
      window.open(this.downloadUrl, '_blank');
    }
  }
};
</script>

<style scoped>
.password-container {
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: auto;
  gap: 5px;
}
.toggle-button, .copy-button, .download-button {
  background: #007bff;
  color: white;
  cursor: pointer;
  height: fit-content;
  min-height: fit-content;
  max-height: fit-content;
  width: fit-content;
  min-width: fit-content;
  margin: auto;
}
.toggle-button:hover, .copy-button:hover, .download-button:hover {
  background: #0056b3;
}
</style>
